'use strict';

function guardedCall(lockObj, data, fn) {
    if (lockObj.guard) return;

    try {
        lockObj.guard = true;
        lockObj.data = data;

        fn();
    } finally {
        lockObj.guard = false;
        lockObj.data = null;
    }
}

function LoggerErrorHandler() {
    var logger = this;
    var loggerError = {guard: false, data: null};
    var loggerDoubleError = {guard: false, data: null};

    function onLoggerError(event) {
        var isRealError;
        var msg;

        if (!event) return;

        isRealError = typeof event.type === 'string' && event.type.indexOf('error') >= 0;
        msg = ['logger', event.source, event.type].join('.');

        if (!loggerError.guard) {
            // First attempts to log a logger failure

            // Make sure we don't attempt to fully log the same error multiple times
            guardedCall(loggerError, event, function loggerErrorEventHandler() {
                // This should allow us to track down what user action caused the logger failure
                var logFn = isRealError ? logger.error : logger.info;
                logFn.call(logger, msg, event.detail);
            });
        } else {
            // Logger Failure Inception!
            // Report as best as we can outside of the badly broken logger message parser

            // Make sure we don't get into a logger error recursion
            guardedCall(loggerDoubleError, event, function loggerDoubleErrorEventHandler() {
                var error = loggerError.data && loggerError.data.detail ?
                                loggerError.data.detail.error : null;
                var doubleError = event.detail ? event.detail.error : null;

                var rawErrorEvent = {
                    level: 'error',
                    arguments: [msg, 'error=', error, 'doubleError=', doubleError]
                };

                var logEntry;

                // Log to console
                logger.signals.onRawLog.dispatch(rawErrorEvent);

                logger.signals.onLineLog.dispatch(rawErrorEvent);

                // And try remotely as well
                logEntry = {
                    seqNum: logger.root.seqNum++,
                    level: 'error',
                    timestamp: (new Date()).toJSON(),
                    msg: msg
                };

                if (error) {
                    logEntry['error.name'] = error.name;
                    logEntry['error.message'] = error.message;
                    if (error.stack) logEntry['error.stack'] = error.stack;
                }

                if (doubleError) {
                    logEntry['doubleError.name'] = doubleError.name;
                    logEntry['doubleError.message'] = doubleError.message;
                    if (doubleError.stack) logEntry['doubleError.stack'] = doubleError.stack;
                }

                logger.signals.onFormattedLog.dispatch({
                    entry: logEntry
                });
            });
        }
    }

    logger.signals.onError.add(onLoggerError);
}

module.exports = {
    pluginName: 'loggerErrorHandler',
    dependencies: ['logger'],

    rootInit: LoggerErrorHandler
};



//////////////////
// WEBPACK FOOTER
// ./~/@getgo/logger/plugins/logger_error_handler.js
// module id = 717
// module chunks = 0